import { spawn } from 'node:child_process'
import { LOCKFILE_REFRESH_TIMEOUT_MS } from '@cli-constants/timeouts.js'

export function runPnpmLockfileOnly(cwd: string): Promise<boolean> {
  return new Promise((resolve) => {
    const child = spawn('pnpm', ['install', '--lockfile-only'], { cwd, stdio: 'ignore' })
    const timer = setTimeout(() => {
      child.kill('SIGKILL')
      resolve(false)
    }, LOCKFILE_REFRESH_TIMEOUT_MS)
    child.on('close', (code) => {
      clearTimeout(timer)
      resolve(code === 0)
    })
    child.on('error', () => {
      clearTimeout(timer)
      resolve(false)
    })
  })
}
